import { cn } from "@/lib/utils";

export type BackendLabelProps = {
  /** The label text to display */
  children: React.ReactNode;
  /** The ID of the input element this label is associated with */
  htmlFor?: string;
  /** Whether this field is required (shows red asterisk) */
  required?: boolean;
  /** Additional CSS classes for styling */
  className?: string;
};

/**
 * Reusable label component for backend forms
 *
 * Provides consistent styling and required indicator across all
 * backend form components. Used by BackendInput, BackendMultiSelect,
 * and other form elements.
 *
 * @example
 * ```tsx
 * <BackendLabel htmlFor="email" required>
 *   E-Mail Adresse
 * </BackendLabel>
 * ```
 */
export function BackendLabel({
  children,
  htmlFor,
  required = false,
  className,
}: BackendLabelProps) {
  return (
    <label htmlFor={htmlFor} className={cn("mb-1 text-xs", className)}>
      {children}
      {required && <span className="ml-1 text-red-500">*</span>}
    </label>
  );
}
